// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Download a Form that Fits Your Situation </h2> <p><a href=\"http://get.adobe.com/reader\">Adobe Acrobat Reader</a> is required to view and print PDF forms. Please retain a copy of the completed form for your records.</p> ";
// Exports
export default code;